import Button from '../../button/Button';
import React from 'react';

import Modal from '../Modal';

import './save-changes-modal.scss';

type Props = {
  show: boolean;
  redirectUrl?: string;
  onSaveClick: () => void;
  onDiscardClick: () => void;
};

const SaveChangesModal = ({ show, onSaveClick, onDiscardClick }: Props) => {
  return (
    <Modal show={show}>
      <div className="save-changes-modal" data-testid="save-changes-modal">
        <div className="save-changes-modal__header">
          <p>Save Changes</p>
        </div>
        <p>Would you like to save your changes?</p>
        <div className="save-changes-modal__button-container">
          <Button text="Discard" onClick={onDiscardClick} />
          <Button text="Save" onClick={onSaveClick} />
        </div>
      </div>
    </Modal>
  );
};

export default SaveChangesModal;
